import React from 'react';
import MyTasksCommon from '../_myTasksCommon';

export default props => (
  <MyTasksCommon
    {...props}
    staticQueryParams={{
      status: 5
    }}
  />
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/MyLockedTasksList/MyLockedTasksList.js